import { useCallback, useState } from "react";
import { refreshOidcAccessToken } from "@/lib/oidcTokenRefresh";

export const useOidcTokenRefresh = () => {
  const [accessToken, setAccessToken] = useState<string | null>(null);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [lastRefreshResult, setLastRefreshResult] = useState<string>("");
  const [hasValidRefreshToken, setHasValidRefreshToken] = useState(false);

  const refreshAccessToken = useCallback(async () => {
    setIsRefreshing(true);
    try {
      const result = await refreshOidcAccessToken();

      if (result.status === "success") {
        setAccessToken(result.tokenInfo.token);
        setHasValidRefreshToken(true);
        setLastRefreshResult("✅ Refresh Success");
        return result.tokenInfo;
      }

      setAccessToken(null);
      setHasValidRefreshToken(false);

      if (result.status === "invalid_refresh_token") {
        setLastRefreshResult("❌ Refresh Token Invalid/Expired");
      } else if (result.status === "http_error") {
        setLastRefreshResult("❌ Refresh Failed");
      } else {
        setLastRefreshResult("❌ Refresh Network Error");
      }

      return null;
    } finally {
      setIsRefreshing(false);
    }
  }, []);

  return {
    accessToken,
    refreshAccessToken,
    isRefreshing,
    lastRefreshResult,
    hasValidRefreshToken,
  };
};
